import { bccLabel } from './RecipientPanel.locstring.json';
import { ccLabel } from 'owa-locstrings/lib/strings/cclabel.locstring.json';
import { upConvertTooltip } from 'owa-locstrings/lib/strings/upconverttooltip.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47713 */
import { ComposeFromMenu, IComposeFromMenu } from 'owa-mail-compose-from-menu';
import ImportanceIcon from './ImportanceIcon';
import { observer } from 'mobx-react';
import { CommandButton, IconButton } from 'office-ui-fabric-react/lib/Button';
import { logUsage } from 'owa-analytics';
import { ControlIcons } from 'owa-control-icons';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import showBccWell from 'owa-mail-compose-actions/lib/actions/showBccWell';
import showCcWell from 'owa-mail-compose-actions/lib/actions/showCcWell';
import switchToReadWriteRecipient from 'owa-mail-compose-actions/lib/actions/switchToReadWriteRecipient';
import updateLastFocusedControl from 'owa-mail-compose-actions/lib/actions/updateLastFocusedControl';
import { ComposeViewState, ComposeControl } from 'owa-mail-compose-store';
import isPublicFolderComposeViewState from 'owa-mail-compose-store/lib/utils/isPublicFolderComposeViewState';
import getMailTipsViewStateMap from 'owa-mail-compose-actions/lib/utils/getMailTipsViewStateMap';
import upConvertHelper from 'owa-mail-compose-actions/lib/utils/onUpconvertHelper';
import { logRecipientRemovedFromRecipientWellDatapoint } from 'owa-mail-tips/lib/datapoints';
import { PostedToLine } from 'owa-public-folder-favorite';
import CompactRecipientWell from 'owa-readonly-recipient-well/lib/components/CompactRecipientWell';
import ReadOnlyRecipientWell from 'owa-readonly-recipient-well/lib/components/ReadOnlyRecipientWell';
import ReadOnlyRecipientViewState from 'owa-readonly-recipient-well/lib/store/schema/ReadOnlyRecipientViewState';
import mergeReadWriteRecipientWellIntoReadOnly from 'owa-readonly-recipient-well/lib/utils/mergeReadWriteRecipientWellIntoReadOnly';
import RecipientWellLabelWithContactPicker from 'owa-recipient-well-label/lib/components/RecipientWellLabelWithContactPicker';
import { RecipientWellLabelWithGALModal } from 'owa-recipient-well-label/lib/components/RecipientWellLabelWithGALModal';
import addRecipientsToRecipientWell from 'owa-recipient-common/lib/actions/addRecipientsToRecipientWell';
import { getReadWriteRecipientViewStateFromFindRecipientPersonaType } from 'owa-recipient-create-viewstate/lib/util/getReadWriteRecipientViewStateFromFindRecipientPersonaType';
import datapoints from 'owa-readwrite-recipient-well/lib/datapoints';
import getRecipientString from 'owa-readwrite-recipient-well/lib/utils/getRecipientString';
import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';
import { RecipientType } from 'owa-recipient-types/lib/types/RecipientType';
import addEntityBySource from 'owa-recipient-common/lib/utils/addEntityBySource';
import addFindPeopleEntityFromResults from 'owa-recipient-common/lib/utils/addFindPeopleEntityFromResults';
import EntityAddSource from 'owa-service/lib/contract/EntityAddSource';

import * as React from 'react';
import RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
import { UncontrolledRecipientWell } from 'owa-readwrite-recipient-well-fabric/lib/components/UncontrolledRecipientWell';
import { AsyncReadWriteRecipientWell } from 'owa-async-readwrite-recipient-well/lib/components/AsyncReadWriteRecipientWell';
import { IFocusable } from 'owa-async-readwrite-recipient-well/lib/types/IFocusable';
import { isFeatureEnabled } from 'owa-feature-flags';

const styles = require('./ComposeTop.scss');
const classNames = require('classnames/bind').bind(styles);
export interface RecipientPanelProps {
    isReadOnly?: boolean;
    /**
     * NOTE: All props (except the last composeViewState prop) below are used in componentWillUpdate
     * Actually all can also be retrieved from composeViewState prop. The reason it is explicitly
     * listed out here is that we need to listen on prop change to adjust scrolling. If the props
     * are not listed out explicitly, React won't fire componentWillUpdate giving you
     * right nextProps and you won't be able to know which prop has changed.
     */
    showCompactRecipientWell: boolean;
    isFromShown: boolean;
    ccRecipientWell: RecipientWellWithFindControlViewState;
    bccRecipientWell: RecipientWellWithFindControlViewState;
    composeViewState: ComposeViewState;
    onContentSizeChanged?: (delta: number, sourceElement: HTMLElement) => void;
    senderPersona?: JSX.Element;
}

@observer
export default class RecipientPanel extends React.Component<RecipientPanelProps, {}> {
    // Map for ComposeControl -> react component
    private controlMap: {
        [ComposeControl.From]?: IComposeFromMenu;
        [ComposeControl.RecipientWellTo]?: IFocusable;
        [ComposeControl.RecipientWellCc]?: IFocusable;
        [ComposeControl.RecipientWellBcc]?: IFocusable;
    } = {};

    // Map for ComposeControl -> attached Html element
    private elementMap: { [key: string]: HTMLElement } = {};

    // The compose control that should be focused post component update
    private autoFocusControl: ComposeControl;

    // The original height and control that trigger the change
    private contentChangeSourceControl: ComposeControl;
    private originalHeight: number;

    // The root element of this component
    private rootElement: HTMLDivElement;

    render() {
        const {
            isFromShown,
            showCompactRecipientWell,
            ccRecipientWell,
            bccRecipientWell,
            composeViewState,
            senderPersona,
        } = this.props;
        const { isInlineCompose, fromViewState, toRecipientWell } = composeViewState;
        const miniButtonPanel = this.renderMiniButtonPanel();
        if (isInlineCompose && showCompactRecipientWell) {
            const containerClassName = classNames(styles.recipientWellLine, styles.compact);
            const compactRecipientWell = (
                <CompactRecipientWell
                    toRecipientWell={toRecipientWell}
                    recipientType={RecipientType.To}
                    ccRecipientWell={ccRecipientWell}
                    onSwitchToReadWriteWell={this.onSwitchToReadWriteRecipient}
                    className={styles.compactRecipientWell}
                />
            );
            return (
                <div
                    className={containerClassName}
                    key="recipientPanelDiv"
                    ref={ref => (this.rootElement = ref)}>
                    {senderPersona}
                    {compactRecipientWell}
                    {miniButtonPanel}
                </div>
            );
        } else {
            const fromField = isFromShown ? (
                <ComposeFromMenu
                    composeViewState={composeViewState}
                    fromViewState={fromViewState}
                    ref={ref => {
                        this.controlMap[ComposeControl.From] = ref;
                        this.elementMap[ComposeControl.From] = ref ? ref.getRootdiv() : null;
                    }}
                />
            ) : null;
            const toRecipient = this.renderRecipientWell(toRecipientWell, RecipientType.To);
            const ccRecipient =
                ccRecipientWell && this.renderRecipientWell(ccRecipientWell, RecipientType.Cc);
            const bccRecipient =
                bccRecipientWell && this.renderRecipientWell(bccRecipientWell, RecipientType.Bcc);

            return (
                <div ref={ref => (this.rootElement = ref)}>
                    {fromField &&
                        this.renderRecipientWellLine(
                            fromField,
                            isPublicFolderComposeViewState(composeViewState)
                                ? null
                                : miniButtonPanel
                        )}
                    {isPublicFolderComposeViewState(composeViewState) ? (
                        this.renderPostedToLine(composeViewState.publicFolderId)
                    ) : (
                        <>
                            {this.renderRecipientWellLine(
                                toRecipient,
                                !fromField ? miniButtonPanel : null
                            )}
                            {ccRecipient && this.renderRecipientWellLine(ccRecipient)}
                            {bccRecipient && this.renderRecipientWellLine(bccRecipient)}
                        </>
                    )}
                </div>
            );
        }
    }

    UNSAFE_componentWillUpdate(nextProps: RecipientPanelProps) {
        if (this.props.isFromShown != nextProps.isFromShown) {
            this.composeControlWillUpdate(ComposeControl.From);
            return;
        }

        if (this.props.showCompactRecipientWell && !nextProps.showCompactRecipientWell) {
            this.composeControlWillUpdate(ComposeControl.RecipientWellTo);
            return;
        }

        if (!this.props.ccRecipientWell && nextProps.ccRecipientWell) {
            this.composeControlWillUpdate(ComposeControl.RecipientWellCc);
            return;
        }

        if (!this.props.bccRecipientWell && nextProps.bccRecipientWell) {
            this.composeControlWillUpdate(ComposeControl.RecipientWellBcc);
            return;
        }
    }

    componentDidUpdate() {
        // Check if there is content size change and notify parent on how much is changed
        if (this.contentChangeSourceControl) {
            const delta = this.rootElement.clientHeight - this.originalHeight;
            const sourceElement = this.elementMap[this.contentChangeSourceControl];
            this.props.onContentSizeChanged(delta, sourceElement);

            // Reset contentChangeSourceControl
            this.contentChangeSourceControl = null;
        }

        if (this.autoFocusControl) {
            switch (this.autoFocusControl) {
                case ComposeControl.RecipientWellTo:
                case ComposeControl.RecipientWellCc:
                case ComposeControl.RecipientWellBcc:
                    const recipientWell = this.controlMap[this.autoFocusControl];
                    if (recipientWell) {
                        recipientWell.focus();
                    }
                    break;
            }

            // Reset it back
            this.autoFocusControl = null;
        }
    }

    /**
     * Focus to a well in the recipient panel if it exists.
     *
     * Does nothing if the well is in a compact display mode.
     *
     * Does not support the from well at present, because the product behaviour is not needed.
     */
    public focus(
        focusTarget:
            | ComposeControl.RecipientWellTo
            | ComposeControl.RecipientWellCc
            | ComposeControl.RecipientWellBcc = ComposeControl.RecipientWellTo
    ): void {
        // Focus can only happen when the recipient well is in read-write
        if (this.props.showCompactRecipientWell) {
            return;
        }

        // Focus goes to To recipient
        const wellToFocus = this.controlMap[focusTarget];
        if (wellToFocus) {
            wellToFocus.focus();
        }
    }

    private renderRecipientWell(
        recipientWell: RecipientWellWithFindControlViewState,
        recipientType: RecipientType
    ): JSX.Element {
        let control: ComposeControl;
        if (recipientType == RecipientType.To) {
            control = ComposeControl.RecipientWellTo;
        } else if (recipientType == RecipientType.Cc) {
            control = ComposeControl.RecipientWellCc;
        } else {
            control = ComposeControl.RecipientWellBcc;
        }

        if (this.props.isReadOnly) {
            const recipients: ReadOnlyRecipientViewState[] = [];
            mergeReadWriteRecipientWellIntoReadOnly(recipientWell, recipients);
            return (
                <div className={styles.recipientWell} ref={ref => (this.elementMap[control] = ref)}>
                    <ReadOnlyRecipientWell
                        wellLabelText={getRecipientString(recipientType)}
                        recipients={recipients}
                        className={styles.readOnlyRecipientWell}
                        allowRenderEmptyWell={true}
                    />
                </div>
            );
        } else {
            return (
                <div className={styles.recipientWell} ref={ref => (this.elementMap[control] = ref)}>
                    {this.renderRWFabricRecipientWell(recipientWell, recipientType, control)}
                </div>
            );
        }
    }

    private renderRWFabricRecipientWell = (
        recipientWell: RecipientWellWithFindControlViewState,
        recipientType: RecipientType,
        control:
            | ComposeControl.RecipientWellTo
            | ComposeControl.RecipientWellCc
            | ComposeControl.RecipientWellBcc
    ): JSX.Element => {
        const onInputFocus = (evt: React.SyntheticEvent<EventTarget>) => {
            updateLastFocusedControl(this.props.composeViewState, control);
        };

        const RecipientWellComponent = isFeatureEnabled('cmp-asyncRecipientWell')
            ? AsyncReadWriteRecipientWell
            : UncontrolledRecipientWell;

        return (
            <RecipientWellComponent
                ref={ref => (this.controlMap[control] = ref)}
                viewState={recipientWell}
                inputProps={{
                    onFocus: onInputFocus,
                }}
                draggableItemType={DraggableItemTypes.ReadWriteRecipient}
                dropViewState={recipientWell.dropViewState}
                recipientType={recipientType}
                onRenderWellLabel={this.renderFabricWellLabel(control, recipientWell)}
                onItemsRemoved={this.logOnItemsRemovedFromInfobar}
                processItemToAdd={this.processItemToAdd(recipientWell)}
                convertInitialItemsToWellItems={items => {
                    return items;
                }}
            />
        );
    };

    private renderFabricWellLabel = (
        control: ComposeControl,
        recipientWell: RecipientWellWithFindControlViewState
    ) => (recipientType: RecipientType) => {
        return isFeatureEnabled('cmp-galRecipientWellModal') ? (
            <RecipientWellLabelWithGALModal
                viewState={recipientWell}
                recipientType={recipientType}
            />
        ) : (
            <RecipientWellLabelWithContactPicker
                recipientType={recipientType}
                addRecipient={this.addRecipientFromContactPicker(recipientWell)}
            />
        );
    };

    private processItemToAdd(recipientWell: RecipientWellWithFindControlViewState) {
        return (
            itemToAdd: ReadWriteRecipientViewState,
            entitySource?: EntityAddSource
        ): boolean => {
            const itemPosition = recipientWell.findResultSet.indexOf(itemToAdd.persona);
            const {
                name: eventName,
                customData: customData,
            } = datapoints.AddRecipientFromFindControl;
            logUsage(eventName, customData(itemPosition, recipientWell.findResultType));

            if (entitySource) {
                addEntityBySource(recipientWell, itemToAdd.persona, itemPosition, entitySource);
            } else {
                addFindPeopleEntityFromResults(recipientWell, itemToAdd.persona, itemPosition);
            }

            return true;
        };
    }

    private logOnItemsRemovedFromInfobar = (recipients, fromExpand) => {
        if (fromExpand) {
            return;
        }

        recipients.forEach(recipient => {
            recipient.persona &&
                recipient.persona.EmailAddress &&
                logRecipientRemovedFromRecipientWellDatapoint(
                    getMailTipsViewStateMap(this.props.ccRecipientWell, [
                        recipient.persona.EmailAddress,
                    ])
                );
        });
    };

    private addRecipientFromContactPicker(recipientWell: RecipientWellWithFindControlViewState) {
        return (recipientToAdd: FindRecipientPersonaType) => {
            addRecipientsToRecipientWell(
                [getReadWriteRecipientViewStateFromFindRecipientPersonaType(recipientToAdd)],
                recipientWell
            );
        };
    }

    private renderPostedToLine(publicFolderId: string): JSX.Element {
        return (
            <div className={styles.recipientWellLine}>
                <PostedToLine folderId={publicFolderId} />
            </div>
        );
    }

    private renderRecipientWellLine(
        normalContent: JSX.Element,
        flowContent?: JSX.Element
    ): JSX.Element {
        return (
            <div className={styles.recipientWellLine}>
                {normalContent}
                {flowContent}
            </div>
        );
    }

    private renderMiniButtonPanel = (): JSX.Element => {
        const {
            showCompactRecipientWell,
            ccRecipientWell,
            bccRecipientWell,
            composeViewState,
        } = this.props;
        const { isInlineCompose, importance } = composeViewState;
        const showRecipientButtonFromIrmData =
            composeViewState.IRMData == null || composeViewState.IRMData.ModifyRecipientsAllowed;
        const showRecipientButton =
            (!isInlineCompose || !showCompactRecipientWell) && showRecipientButtonFromIrmData;
        return (
            <div className={styles.miniRecipientButtonContainer}>
                {isInlineCompose && <ImportanceIcon importance={importance} />}
                {showRecipientButton && !ccRecipientWell && (
                    <CommandButton onClick={this.onShowCc} className={styles.miniButton}>
                        {loc(ccLabel)}
                    </CommandButton>
                )}
                {showRecipientButton && !bccRecipientWell && (
                    <CommandButton onClick={this.onShowBcc} className={styles.miniButton}>
                        {loc(bccLabel)}
                    </CommandButton>
                )}
                {isInlineCompose && (
                    <IconButton
                        title={loc(upConvertTooltip)}
                        iconProps={{ iconName: ControlIcons.FullScreen }}
                        onClick={this.onUpConvert}
                        className={styles.miniButton}
                        ariaLabel={loc(upConvertTooltip)}
                    />
                )}
            </div>
        );
    };

    private onUpConvert = async () => {
        upConvertHelper(this.props.composeViewState);
        this.autoFocusControl = ComposeControl.RecipientWellCc;
    };

    private onShowCc = () => {
        showCcWell(this.props.composeViewState);
        this.autoFocusControl = ComposeControl.RecipientWellCc;
    };

    private onShowBcc = () => {
        showBccWell(this.props.composeViewState);
        this.autoFocusControl = ComposeControl.RecipientWellBcc;
    };

    private onSwitchToReadWriteRecipient = () => {
        switchToReadWriteRecipient(this.props.composeViewState);
        this.autoFocusControl = ComposeControl.RecipientWellTo;
    };

    private composeControlWillUpdate = (composeControl: ComposeControl) => {
        this.contentChangeSourceControl = composeControl;
        this.originalHeight = this.rootElement.clientHeight;
    };
}
